
import { mapActions } from 'vuex'
import store from '../../config/store'

export default {
  components: {
    'component-button': () => import(/* webpackChunkName: "components" */ '@/common/components/Button.vue'),
  },

  data: () => ({
    dropdown: false,
    password: '',
    incorrectPassword: false,
    incorrectPasswordMessage: ''
  }),
  methods: {
    ...mapActions([
      'checkUserPassword'
    ]),

    onCloseModal () {
      store.modal.active = false
    },

    onValidate () {
      store.api.hideBanner = true
      this.incorrectPassword = false
      this.checkUserPassword(this.password).then(() => {
        store.api.hideBanner = false
        this.$bus.$emit('password-checked', store.modal.dataModel.action)
        this.onCloseModal()
      }, (error) => {
        store.api.hideBanner = false
        this.incorrectPassword = true
        this.incorrectPasswordMessage = error.response.data[0].message
      })
    }
  }
}
